import { RootState } from '../types/store'

export const getConstructorState = (store: RootState) => store.constructorState
